import {
    GetLeaveResponseInterface,
    UpdateLeavePayloadInterface,
} from '@/models/leave.model';
import axiosService from '@/services/axios/axios.service';

const getLeaves = async (payload: {
    status?: string;
    month?: string;
    limit?: number;
    page?: number;
    uid?: string;
}): Promise<NonNullable<GetLeaveResponseInterface>> => {
    const res = await axiosService.get(`/leave/get-leaves-by-admin`, {
        params: payload,
    });
    return res.data;
};

const updateLeaves = async (
    payload: UpdateLeavePayloadInterface
): Promise<NonNullable<any>> => {
    const res = await axiosService.post(`/leave/update-leave`, payload);
    return res.data;
};

export { getLeaves, updateLeaves };
